
import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/aura/HeroSection";
import TransformingSecuritySection from "@/components/aura/TransformingSecuritySection";
import WhyEnterprisesSection from "@/components/aura/WhyEnterprisesSection";
import CoreCapabilitiesSection from "@/components/aura/CoreCapabilitiesSection";
import HowItWorksSection from "@/components/aura/HowItWorksSection";
import KeyDifferentiatorsSection from "@/components/aura/KeyDifferentiatorsSection";
import TrustworthyAISection from "@/components/aura/TrustworthyAISection";
import IntegrationEcosystemSection from "@/components/aura/IntegrationEcosystemSection";
import BusinessImpactSection from "@/components/aura/BusinessImpactSection";
import CTASection from "@/components/aura/CTASection";
import FAQSection from "@/components/aura/FAQSection";
import CanonicalTag from "@/components/seo/CanonicalTag";

const AuraXPTechnology = () => {
  useEffect(() => {
    document.title = "AuraXP - Your Organization's Intelligent Cyber Brain | Spharaka Networks";
    
    const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', 'AuraXP by Spharaka Networks: Autonomous Unified Response Agent with Xtended Protection. Transform security operations into autonomous intelligence with predictive cyber defense.');
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDescription);
    }

    window.scrollTo(0, 0);

    return () => {
      try {
        if (metaDescription.parentNode) {
          document.head.removeChild(metaDescription);
        }
      } catch (e) {}
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <CanonicalTag path="/products/auraxp" />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <TransformingSecuritySection />
        <WhyEnterprisesSection />
        <CoreCapabilitiesSection />
        <HowItWorksSection />
        <KeyDifferentiatorsSection />
        <TrustworthyAISection />
        <IntegrationEcosystemSection />
        <BusinessImpactSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default AuraXPTechnology;
